import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { ProgressBar } from 'react-native-paper';
import Card from './Card'
import { MainColors } from '../constants/Colors';
import FontSizes from '../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const BallotCard = (props) => {
    return (
        <Card onPress={props.onPress} disabled={props.disabled} testId={props.testId}>
            <View style={styles.cardHeader}>
                <View style={{ width: '90%' }}>
                    <Text style={styles.cardTitle}>{props.cardTitle}</Text>
                </View>

                {props.editButtonShown ? (
                    <View>
                        <TouchableOpacity style={styles.editButton} onPress={props.onEditButtonPress}>
                            <MaterialCommunityIcons name="square-edit-outline" size={24}
                                color={MainColors.primary} />
                        </TouchableOpacity>
                    </View>
                ) : (<View></View>)
                }
            </View>

            <View style={styles.cardContent}>
                {props.statusLabel === 'Pending' ? (
                    <Text style={styles.votingTimeWindow}>Voting Begins {props.startDate}</Text>
                )
                    : props.statusLabel === 'Active' ? (
                        <Text style={styles.votingTimeWindow}>Time Remaining: {props.timeRemaining}</Text>
                    )
                        : (
                            <Text style={styles.votingTimeWindow}>Time's up! The booths are closed.</Text>
                        )}

                <ProgressBar style={styles.progressBar} color={MainColors.secondary}
                    progress={props.progressDecimal}
                />

                <Text style={styles.percentVotedLabel}>
                    {(props.progressDecimal * 100).toFixed()}% Voted</Text>

                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 15 }}>
                    <Text style={[styles.statusLabelStyle, props.statusStyle]}>{props.statusLabel}</Text>
                    {props.hasBeenVotedOn
                        ? <Text style={styles.hasBeenVotedOnLabel}>We got your vote! 😎</Text>
                        : null
                    }
                </View>

            </View>
        </Card>
    )
}

const styles = StyleSheet.create({
    cardHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        borderBottomWidth: 1,
        borderBottomColor: MainColors.faintGray,
        padding: 15,
    },
    cardContent: {
        padding: 15,
    },
    cardTitle: {
        fontSize: FontSizes.large,
        fontWeight: '600',
        color: MainColors.darkGray,
        letterSpacing: 0.5,
        lineHeight: 24,
        flex: 1,
        flexWrap: 'wrap',
    },
    editButton: {
        alignSelf: 'flex-start',
        paddingLeft: 8,
    },
    votingTimeWindow: {
        fontSize: FontSizes.medium,
        color: MainColors.mediumGray,
        marginBottom: 20,
        fontWeight: '500',
    },
    votingTimeContainer: {
        fontSize: FontSizes.small,
        color: MainColors.mediumGray,
        marginBottom: 20,
        fontWeight: '500'
    },
    progressBar: {
        height: 12,
        borderRadius: 10,
        backgroundColor: MainColors.faintGray
    },
    percentVotedLabel: {
        textAlign: 'right',
        color: MainColors.mediumGray,
        fontSize: FontSizes.extraSmall,
        fontWeight: '600'
    },
    statusLabelStyle: {
        fontWeight: '500',
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        letterSpacing: 0.5
    },
    hasBeenVotedOnLabel: {
        fontSize: FontSizes.medium,
        fontWeight: '500',
        color: MainColors.darkGray,
        letterSpacing: 0.5,
    }
});

export default React.memo(BallotCard);